import ProgressBar from '@/components/base/ProgressBar';
import type { ScoreState } from '@/lib/exercise/engine';

interface ScorePanelProps {
  score: ScoreState;
  accuracy: number;
  streak: number;
  streakGoal: number;
}

export default function ScorePanel({ score, accuracy, streak, streakGoal }: ScorePanelProps) {
  const stats = [
    {
      label: 'Erros',
      value: score.wrong,
      icon: 'ri-close-line',
      color: 'text-secondary-700 bg-secondary-100',
    },
    {
      label: 'Tentativas',
      value: score.total,
      icon: 'ri-repeat-line',
      color: 'text-foreground-700 bg-background-200',
    },
    {
      label: 'Precisão',
      value: `${accuracy}%`,
      icon: 'ri-percent-line',
      color: 'text-foreground-700 bg-background-200',
    },
  ];

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="rounded-md bg-primary-50 px-3 py-2.5">
        <div className="flex items-center justify-between">
          <span className="font-label text-sm font-bold text-primary-800">Combo de acertos</span>
          <span className="font-heading text-lg font-bold text-primary-700">
            {streak}/{streakGoal}
          </span>
        </div>
        <div className="mt-2">
          <ProgressBar value={streak} max={streakGoal} tone="primary" />
        </div>
      </div>

      <div className="mt-4 grid grid-cols-3 gap-3">
        {stats.map((item) => (
          <div key={item.label} className="flex items-center gap-2">
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-md ${item.color} shrink-0`}
            >
              <i className={`${item.icon} text-base`} />
            </span>
            <div className="min-w-0">
              <div className="font-heading text-lg font-bold leading-none text-foreground-950">
                {item.value}
              </div>
              <div className="text-xs text-foreground-500 truncate">{item.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}